/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

import { Chip } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { VerticallyAlignedFlexContainer, StyledTooltip } from 'styles/common';

import theme from 'constants/theme';

import { getNotificationEventChannelDetails, resetDefaultNotificationSettingsForEmployees } from 'services/admin';
import { showErrorSnackbar, showSuccessSnackbar } from 'services/snackbar';

import { Typography13 } from 'uiToolkit/Typography';
import { Button } from 'uiToolkitV1/Button';
import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { useNotificationSettings } from './Context/NotificationSettingsContext';

const NotificationFooterActionRow = ({
  onClick = () => {},
  text = '',
  showAdminTag = false,
  buttonText = 'Confirm',
}) => (
  <Container>
    <PaperWithShadow p="16px">
      <VerticallyAlignedFlexContainer>
        <Typography13>{text}</Typography13>
        {showAdminTag && (
          <StyledTooltip title="This functionality is only available to platform admins">
            <AdminTag label="Admin" />
          </StyledTooltip>
        )}
        <Button onClick={onClick} style={{ marginLeft: 'auto', width: '10rem' }} variant="outlined">
          {buttonText}
        </Button>
      </VerticallyAlignedFlexContainer>
    </PaperWithShadow>
  </Container>
);

const NotificationSettingsFooter = ({ isEmployeeNotificationSettings = false }) => {
  const dispatch = useDispatch();
  const {
    state: { loadingChannelDetails },
    setData,
  } = useNotificationSettings();

  const { enabledFeatures = [] } = useSelector(selectLoggedInEmployeeData);

  const fetchData = () => {
    getNotificationEventChannelDetails({ isEmployeeNotificationSettings, enabledFeatures }).then((res) =>
      setData({ ...res, loadingChannelDetails: false })
    );
  };

  const resetToDefaultSettingsHandler = () => {
    resetDefaultNotificationSettingsForEmployees()
      .then(() => {
        fetchData();
        dispatch(showSuccessSnackbar('Settings reset successful!'));
      })
      .catch((err) => {
        dispatch(showErrorSnackbar('Error in resetting'));
        console.error('Error resetting notification settings : ', err);
      });
  };

  if (!isEmployeeNotificationSettings) {
    return null;
  }

  if (loadingChannelDetails) {
    return <Skeleton />;
  }

  return (
    <Container>
      <NotificationFooterActionRow
        onClick={() => resetToDefaultSettingsHandler()}
        text="Reset to my organization's default settings"
        buttonText="Reset"
      />
    </Container>
  );
};

const Container = styled.div`
  margin: 12px 0;
`;
const AdminTag = styled(Chip)`
  color: white;
  background-color: ${theme.palette.green.main};
  font-size: 0.875rem;
  height: 1.625rem;
  padding: 0 0.75rem;
  margin-left: 1rem;
`;

export default NotificationSettingsFooter;
